// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BgSection_bgImage__VxJk\\+ {
  height: 100%;
  object-fit: cover;
  object-position: 100% 30%;
  width: 100%;
}

.BgSection_horizontal__RbH1H {
  height: 382px;
  width: 100%;
  position: relative;
}

.BgSection_vertical__Zpxfi {
  height: 100%;
  width: 30%;
  max-width: 448px;
}

.BgSection_content__t7Q5l {
  height: inherit;
  text-align: center;
  width: inherit;
}

.BgSection_top__pkFDf {
  position: absolute;
  top: 0%;
  padding: 0 60px;
}

.BgSection_left__u9vQy {
  position: absolute;
  left: 0%;
}

.BgSection_right__5dWOA {
  position: absolute;
  right: 0%;
}

.BgSection_middle__WoUYJ {
  position: absolute;
  top: 0;
  left: 0;
}

.BgSection_primary__a4uQv {
  background-color: #1f1f1f;
}

@media only screen and (max-width: 1300px) {
  .BgSection_vertical__Zpxfi {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/BgSection/BgSection.module.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,UAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,OAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;AADF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AADF;;AAIA;EACE,yBC7CU;AD4CZ;;AAIA;EACE;IACE,aAAA;EADF;AACF","sourcesContent":["@use \"styles/colors\";\n\n.bgImage {\n  height: 100%;\n  object-fit: cover;\n  object-position: 100% 30%;\n  width: 100%;\n}\n\n.horizontal {\n  height: 382px;\n  width: 100%;\n  position: relative;\n}\n\n.vertical {\n  height: 100%;\n  width: 30%;\n  max-width: 448px;\n}\n\n.content {\n  height: inherit;\n  text-align: center;\n  width: inherit;\n}\n\n.top {\n  position: absolute;\n  top: 0%;\n  padding: 0 60px;\n}\n\n.left {\n  position: absolute;\n  left: 0%;\n}\n\n.right {\n  position: absolute;\n  right: 0%;\n}\n\n.middle {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.primary {\n  background-color: colors.$secondary;\n}\n\n@media only screen and (max-width: 1300px) {\n  .vertical {\n    display: none;\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bgImage": `BgSection_bgImage__VxJk+`,
	"horizontal": `BgSection_horizontal__RbH1H`,
	"vertical": `BgSection_vertical__Zpxfi`,
	"content": `BgSection_content__t7Q5l`,
	"top": `BgSection_top__pkFDf`,
	"left": `BgSection_left__u9vQy`,
	"right": `BgSection_right__5dWOA`,
	"middle": `BgSection_middle__WoUYJ`,
	"primary": `BgSection_primary__a4uQv`
};
export default ___CSS_LOADER_EXPORT___;
